export default __webpack_public_path__ + "static/media/muralesang.f420c8d2.avif";